export const MY_FORMATS = {
    parse: {
        dateInput: 'D/MM/YYYY'
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMMM Y',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM Y'
    }
};



// WEBPACK FOOTER //
// ./src/app/main/const/date-format.ts